import {Box, Typography} from '@mui/material';
import './TextDocTab.scss';
import {useTextViewDoc} from '../../../../../hooks/document/useDocument';
import {t} from 'i18next';
import React from 'react';
import ArrLoadingSpinner from '../../../../common/arr-loading-spinner/ArrLoadingSpinner';

type TextDocTabProps = {
  docId: number;
};
const enTextDocTab = 'docView.textViewTab';
const TextDocTab: React.FC<TextDocTabProps> = ({docId}) => {
  const {data: docContent, isPending: isLoading} = useTextViewDoc(
    docId,
    docId > 0
  );
  const content = docContent?.fileContent;
  const isError = docContent?.hasErrorOccurred;
  const isFileAttached = docContent?.hasFile;

  return (
    <Box className="text-doc-view-box">
      {isLoading ? (
        <ArrLoadingSpinner />
      ) : (
        <>
          {content ? (
            <div
              id="divViewerText"
              data-testid="text-doc-content"
              className="doc-content"
              dangerouslySetInnerHTML={{__html: content}}
            />
          ) : (
            <Typography
              className="doc-content"
              data-testid={`text-doc-tab-text`}
            >
              {t(
                `${enTextDocTab}.${isError ? 'errorMsg' : !isFileAttached && 'noData'}`
              )}
            </Typography>
          )}
        </>
      )}
    </Box>
  );
};

export default TextDocTab;
